export interface IAvailableWeek {
  weekNumber: number
  period: string
}

export interface IAvailableWeeksReponse {
  availableWeeks: IAvailableWeek[]
}
